import { useEffect } from "react";
import { useAuth } from "@/app/auth";
import { useWorkspace } from "@/api/workspace";
import { lockVersion } from "./store";
import { syncAll } from "./sync";
import { refreshOwner } from "./identity";

export function OfflineSyncBridge() {
    const { user } = useAuth();
    const workspace = useWorkspace();
    useEffect(() => {
        if (!user) return;
        let stopped = false;
        let generation = lockVersion();
        const refresh = async () => {
            if (!navigator.onLine || stopped || generation !== lockVersion()) return;
            try { const owner = await refreshOwner(true); generation = lockVersion(); if (!stopped) await syncAll(owner); }
            catch { /* Preserve local work through outages and module deployments. */ }
        };
        void refresh();
        const online = () => void refresh();
        window.addEventListener("online", online);
        const timer = window.setInterval(online, 30_000);
        return () => { stopped = true; window.removeEventListener("online", online); window.clearInterval(timer); };
    }, [user?.id, user?.company?.id, workspace]);
    return null;
}
